import axios from 'axios'

const base_url = '/questionnaires'

export default {

    async createQuestion(question_data) {
        return await axios.post(`${base_url}/questions`, question_data)
    },

    async createQuestionnaire(questionnaire_data) {
        return await axios.post(base_url, questionnaire_data)
    },

  async fetchAllGroupQuestionnaires(group_id) {
        return await axios.get(`${base_url}/group/${group_id}`)
    },

    async getAllGroupQuestions(group_id) {
        return await axios.get(`${base_url}/questions/group/${group_id}`)
    },

    async fetchQuestion(question_id) {
        return await axios.get(`${base_url}/questions/${question_id}`)
    },

    async fetchQuestionForTest(question_id) {
        return await axios.get(`${base_url}/questions/test/${question_id}`)
    },

    async fetchQuestionnaireData(questionnaire_id) {
        return await axios.get(`${base_url}/${questionnaire_id}`)
    },

    async fetchQuestionnaireResultData(questionnaire_id) {
        return await axios.get(`${base_url}/result/${questionnaire_id}`)
    },

    /**
     * @desc Every answer to a questionnaire, one entry per respondent, for the
     *       teacher's CSV export. Anonymous — respondent numbers, no user ids.
     * @param {number} questionnaire_id
     * @return {Promise} response
     */
    async fetchQuestionnaireResponses(questionnaire_id) {
        return await axios.get(`${base_url}/result/${questionnaire_id}/responses`)
    },

    /**
     * @desc Every evaluation on the institution's holds, for the school-wide
     *       download in Administration. Needs admin_stats + can_view_teacher_activity.
     * @param {number} institution_id
     * @return {Promise} response
     */
    async fetchInstitutionQuestionnaires(institution_id) {
        return await axios.get(`/statistics/institution/questionnaires/${institution_id}`)
    },

    /**
     * @desc fetchQuestionnaireResponses for up to 100 of the institution's
     *       questionnaires at once. Ids outside the institution are left out.
     * @param {number} institution_id
     * @param {Array<number>} questionnaire_ids
     * @return {Promise} response
     */
    async fetchInstitutionQuestionnaireResponses(institution_id, questionnaire_ids) {
        return await axios.post('/statistics/institution/questionnaires/responses', { institution_id, questionnaire_ids })
    },

    /**
     * @desc Register questionnaire start
     * @param {Object} data - Questionnaire data
     * @param {number} data.questionnaire_id
     * @param {boolean} isMockStudent 
     * @return {Promise} response
     */
    async registerQuestionnaireStarted(data, isMockStudent = false) {
      const { questionnaire_id } = data

      // Handle real user
      if (!isMockStudent) return await axios.put(`${base_url}/start/${questionnaire_id}`, {})

      // Mock response
      return {
        data: {
          questionnaire_started: Date.now() / 1000,
        },
      }
    },

    /**
     * @desc Register questionnaire end
     * @param {Object} data - Questionnaire data
     * @param {number} data.questionnaire_id
     * @param {boolean} isMockStudent 
     * @return {Promise} response
     */
    async registerQuestionnaireEnded(data, isMockStudent = false) {
      const { questionnaire_id } = data

      // Handle real user
      if (!isMockStudent) return await axios.put(`${base_url}/end/${questionnaire_id}`, {})

      // Mock response
      return {
        data: {
          questionnaire_ended: Date.now() / 1000,
        },
      }
    },

    async removeQuestion(question_id) {
        return await axios.delete(`${base_url}/question/${question_id}`)
    },

    async removeQuestionnaire(questionnaire_id) {
        return await axios.delete(`${base_url}/${questionnaire_id}`)
    },

    async saveQuestion(question_id, question_data) {
        return await axios.put(`${base_url}/questions/${question_id}`, question_data)
    },

    async saveQuestionnaire(questionnaire_id, questionnaire_data) {
        return await axios.put(`${base_url}/${questionnaire_id}`, questionnaire_data)
    },

    /**
     * @desc Save user questionnaire answer
     * @param {Object} data - Questionnaire data
     * @param {Object} data.question_data
     * @param {boolean} isMockStudent 
     * @return {Promise} response
     */
    async saveUserQuestionnaireAnswer(data, isMockStudent = false) {
      const { question_data } = data

      if (!isMockStudent) return await axios.post(`${base_url}/answer`, question_data)

      return {
        data: {
          ...question_data,
        },
      }
    },


}
